module.exports = __webpack_public_path__ + "media/images/index/area/faeture_okinawa-4f7dd2b6c8165fa48911424b47b719f7.png";